export const POLICY_GROUP_PROGRAM_MIST = 'program:mist';
export const POLICY_GROUP_PROGRAM_FIST = 'program:fist';
export const POLICY_GROUP_PROGRAM_ODRH = 'program:odrh';
export const POLICY_GROUP_PROGRAM_PRGWMN = 'program:prgwmn';
export const POLICY_GROUP_PROGRAM_DSH = 'program:dsh';
export const POLICY_GROUP_PROGRAM_LEAD = 'program:lead';
export const POLICY_GROUP_CANDIDATE = 'program:participant:candidates';
export const POLICY_GROUP_REPORT = 'tools:reports:access';
export const POLICY_GROUP_INREP_ACCESS = 'tools:inrepaccess';
export const POLICY_GROUP_PROGRESS_REPORT_ACCESS = 'tools:progressreportaccess';
export const POLICY_GROUP_CASECONFERENCE = 'tools:caseconference';
export const POLICY_GROUP_COURT_CALENDAR = 'tools:courtcalendar';
export const POLICY_GROUP_HOUSING = 'tools:housing';
export const POLICY_GROUP_DOC_LIBRARY_EXTERNAL = 'tools:docslib:external';
export const POLICY_GROUP_DOC_LIBRARY_INTERNAL = 'tools:docslib:internal';
export const POLICY_GROUP_DOC_LIBRARY_ADMIN = 'tools:docslib:admin';
export const POLICY_GROUP_LAI_JAIL_READ = 'tools:lai:jail:read';
export const POLICY_GROUP_LAI_JAIL_WRITE = 'tools:lai:jail:write';
export const POLICY_GROUP_MEDCALL_STANDARD = 'tools:medcall:access';
export const POLICY_GROUP_MEDCALL_POWER_USER = 'tools:medcall:power';
export const POLICY_GROUP_NOTIFICATION_LOG = 'tools:notifications';
export const POLICY_GROUP_NOTIFICATIONS_VIA_OUTLOOK = 'tools:notificationsviaoutlook';
export const POLICY_GROUP_REFERRAL_INTAKE = 'tools:publicdefenderslist';
export const POLICY_GROUP_USER_ACCOUNT_REQUESTS = 'tools:requestuser';
export const POLICY_GROUP_BILLING = 'tools:billing:access';
export const POLICY_GROUP_BILLING_ADMIN = 'tools:billing:admin';

export const POLICY_BACKED_ACCESS_PROGRAM_MIST = POLICY_GROUP_PROGRAM_MIST;
export const POLICY_BACKED_ACCESS_PROGRAM_FIST = POLICY_GROUP_PROGRAM_FIST;
export const POLICY_BACKED_ACCESS_PROGRAM_ODRH = POLICY_GROUP_PROGRAM_ODRH;
export const POLICY_BACKED_ACCESS_PROGRAM_PRGWMN = POLICY_GROUP_PROGRAM_PRGWMN;
export const POLICY_BACKED_ACCESS_PROGRAM_DSH = POLICY_GROUP_PROGRAM_DSH;
export const POLICY_BACKED_ACCESS_PROGRAM_LEAD = POLICY_GROUP_PROGRAM_LEAD;
export const POLICY_BACKED_ACCESS_CANDIDATE = POLICY_GROUP_CANDIDATE;
export const POLICY_BACKED_ACCESS_REPORT = POLICY_GROUP_REPORT;
export const POLICY_BACKED_ACCESS_INREP = POLICY_GROUP_INREP_ACCESS;
export const POLICY_BACKED_ACCESS_PROGRESS_REPORT = POLICY_GROUP_PROGRESS_REPORT_ACCESS;
export const POLICY_BACKED_ACCESS_CASECONFERENCE = POLICY_GROUP_CASECONFERENCE;
export const POLICY_BACKED_ACCESS_COURT_CALENDAR = POLICY_GROUP_COURT_CALENDAR;
export const POLICY_BACKED_ACCESS_HOUSING = POLICY_GROUP_HOUSING;
export const POLICY_BACKED_ACCESS_DOC_LIBRARY_EXTERNAL = POLICY_GROUP_DOC_LIBRARY_EXTERNAL;
export const POLICY_BACKED_ACCESS_DOC_LIBRARY_INTERNAL = POLICY_GROUP_DOC_LIBRARY_INTERNAL;
export const POLICY_BACKED_ACCESS_DOC_LIBRARY_ADMIN = POLICY_GROUP_DOC_LIBRARY_ADMIN;
export const POLICY_BACKED_ACCESS_LAI_JAIL = 'policy:lai-jail';
export const POLICY_BACKED_ACCESS_LAI_JAIL_WRITE = 'policy:lai-jail-write';
export const POLICY_BACKED_ACCESS_MEDCALL_STANDARD = POLICY_GROUP_MEDCALL_STANDARD;
export const POLICY_BACKED_ACCESS_MEDCALL_POWER_USER = POLICY_GROUP_MEDCALL_POWER_USER;
export const POLICY_BACKED_ACCESS_NOTIFICATION_LOG = 'notificationlog';
export const POLICY_BACKED_ACCESS_NOTIFICATIONS_VIA_OUTLOOK = POLICY_GROUP_NOTIFICATIONS_VIA_OUTLOOK;
export const POLICY_BACKED_ACCESS_REFERRAL_INTAKE = POLICY_GROUP_REFERRAL_INTAKE;
export const POLICY_BACKED_ACCESS_USER_ACCOUNT_REQUESTS = POLICY_GROUP_USER_ACCOUNT_REQUESTS;
export const POLICY_BACKED_ACCESS_BILLING = POLICY_GROUP_BILLING;
export const POLICY_BACKED_ACCESS_BILLING_ADMIN = POLICY_GROUP_BILLING_ADMIN;

export const POLICY_ALIAS_DOC_LIBRARY_EXTERNAL = 'Doc Library External';
export const POLICY_ALIAS_DOC_LIBRARY_INTERNAL = 'Doc Library Internal';
export const POLICY_ALIAS_DOC_LIBRARY_ADMIN = 'Doc Library Admin';
export const POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY = 'Documents Library';
export const POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY_WRITE = 'Documents Library (write)';
export const POLICY_ALIAS_MEDCALL_STANDARD = 'MedCall Standard';
export const POLICY_ALIAS_LEGACY_MEDCALL = 'MedCall';
export const POLICY_ALIAS_MEDCALL_POWER_USER = 'MedCall Power User';

const POLICY_BACKED_ACCESS_MAP: Record<string, string[]> = {
  [POLICY_BACKED_ACCESS_PROGRAM_MIST]: [POLICY_GROUP_PROGRAM_MIST],
  [POLICY_BACKED_ACCESS_PROGRAM_FIST]: [POLICY_GROUP_PROGRAM_FIST],
  [POLICY_BACKED_ACCESS_PROGRAM_ODRH]: [POLICY_GROUP_PROGRAM_ODRH],
  [POLICY_BACKED_ACCESS_PROGRAM_PRGWMN]: [POLICY_GROUP_PROGRAM_PRGWMN],
  [POLICY_BACKED_ACCESS_PROGRAM_DSH]: [POLICY_GROUP_PROGRAM_DSH],
  [POLICY_BACKED_ACCESS_PROGRAM_LEAD]: [POLICY_GROUP_PROGRAM_LEAD],
  [POLICY_BACKED_ACCESS_CANDIDATE]: [POLICY_GROUP_CANDIDATE],
  [POLICY_BACKED_ACCESS_REPORT]: [POLICY_GROUP_REPORT],
  [POLICY_BACKED_ACCESS_INREP]: [POLICY_GROUP_INREP_ACCESS],
  [POLICY_BACKED_ACCESS_PROGRESS_REPORT]: [POLICY_GROUP_PROGRESS_REPORT_ACCESS],
  [POLICY_BACKED_ACCESS_CASECONFERENCE]: [POLICY_GROUP_CASECONFERENCE],
  [POLICY_BACKED_ACCESS_COURT_CALENDAR]: [POLICY_GROUP_COURT_CALENDAR],
  [POLICY_BACKED_ACCESS_HOUSING]: [POLICY_GROUP_HOUSING],
  [POLICY_BACKED_ACCESS_DOC_LIBRARY_EXTERNAL]: [POLICY_GROUP_DOC_LIBRARY_EXTERNAL],
  [POLICY_BACKED_ACCESS_DOC_LIBRARY_INTERNAL]: [POLICY_GROUP_DOC_LIBRARY_INTERNAL],
  [POLICY_BACKED_ACCESS_DOC_LIBRARY_ADMIN]: [POLICY_GROUP_DOC_LIBRARY_ADMIN],
  [POLICY_BACKED_ACCESS_LAI_JAIL]: [POLICY_GROUP_LAI_JAIL_READ],
  [POLICY_BACKED_ACCESS_LAI_JAIL_WRITE]: [POLICY_GROUP_LAI_JAIL_WRITE],
  [POLICY_BACKED_ACCESS_MEDCALL_STANDARD]: [POLICY_GROUP_MEDCALL_STANDARD],
  [POLICY_BACKED_ACCESS_MEDCALL_POWER_USER]: [POLICY_GROUP_MEDCALL_POWER_USER],
  [POLICY_BACKED_ACCESS_NOTIFICATION_LOG]: [POLICY_GROUP_NOTIFICATION_LOG],
  [POLICY_BACKED_ACCESS_NOTIFICATIONS_VIA_OUTLOOK]: [POLICY_GROUP_NOTIFICATIONS_VIA_OUTLOOK],
  [POLICY_BACKED_ACCESS_REFERRAL_INTAKE]: [POLICY_GROUP_REFERRAL_INTAKE],
  [POLICY_BACKED_ACCESS_USER_ACCOUNT_REQUESTS]: [POLICY_GROUP_USER_ACCOUNT_REQUESTS],
  [POLICY_BACKED_ACCESS_BILLING]: [POLICY_GROUP_BILLING],
  [POLICY_BACKED_ACCESS_BILLING_ADMIN]: [POLICY_GROUP_BILLING_ADMIN]
};

const POLICY_CONFLICT_GROUPS_BY_ACCESS: Record<string, string[]> = {
  [POLICY_BACKED_ACCESS_PROGRAM_MIST]: [POLICY_GROUP_PROGRAM_MIST],
  [POLICY_BACKED_ACCESS_PROGRAM_FIST]: [POLICY_GROUP_PROGRAM_FIST],
  [POLICY_BACKED_ACCESS_PROGRAM_ODRH]: [POLICY_GROUP_PROGRAM_ODRH],
  [POLICY_BACKED_ACCESS_PROGRAM_PRGWMN]: [POLICY_GROUP_PROGRAM_PRGWMN],
  [POLICY_BACKED_ACCESS_PROGRAM_DSH]: [POLICY_GROUP_PROGRAM_DSH],
  [POLICY_BACKED_ACCESS_PROGRAM_LEAD]: [POLICY_GROUP_PROGRAM_LEAD],
  [POLICY_BACKED_ACCESS_CANDIDATE]: [POLICY_GROUP_CANDIDATE],
  [POLICY_BACKED_ACCESS_REPORT]: [POLICY_GROUP_REPORT],
  [POLICY_BACKED_ACCESS_INREP]: [POLICY_GROUP_INREP_ACCESS],
  [POLICY_BACKED_ACCESS_PROGRESS_REPORT]: [POLICY_GROUP_PROGRESS_REPORT_ACCESS],
  [POLICY_BACKED_ACCESS_CASECONFERENCE]: [POLICY_GROUP_CASECONFERENCE],
  [POLICY_BACKED_ACCESS_COURT_CALENDAR]: [POLICY_GROUP_COURT_CALENDAR],
  [POLICY_BACKED_ACCESS_HOUSING]: [POLICY_GROUP_HOUSING],
  [POLICY_BACKED_ACCESS_DOC_LIBRARY_EXTERNAL]: [
    POLICY_GROUP_DOC_LIBRARY_EXTERNAL,
    POLICY_GROUP_DOC_LIBRARY_INTERNAL,
    POLICY_GROUP_DOC_LIBRARY_ADMIN,
    POLICY_ALIAS_DOC_LIBRARY_EXTERNAL,
    POLICY_ALIAS_DOC_LIBRARY_INTERNAL,
    POLICY_ALIAS_DOC_LIBRARY_ADMIN,
    POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY,
    POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY_WRITE
  ],
  [POLICY_BACKED_ACCESS_DOC_LIBRARY_INTERNAL]: [
    POLICY_GROUP_DOC_LIBRARY_EXTERNAL,
    POLICY_GROUP_DOC_LIBRARY_INTERNAL,
    POLICY_GROUP_DOC_LIBRARY_ADMIN,
    POLICY_ALIAS_DOC_LIBRARY_EXTERNAL,
    POLICY_ALIAS_DOC_LIBRARY_INTERNAL,
    POLICY_ALIAS_DOC_LIBRARY_ADMIN,
    POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY,
    POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY_WRITE
  ],
  [POLICY_BACKED_ACCESS_DOC_LIBRARY_ADMIN]: [
    POLICY_GROUP_DOC_LIBRARY_EXTERNAL,
    POLICY_GROUP_DOC_LIBRARY_INTERNAL,
    POLICY_GROUP_DOC_LIBRARY_ADMIN,
    POLICY_ALIAS_DOC_LIBRARY_EXTERNAL,
    POLICY_ALIAS_DOC_LIBRARY_INTERNAL,
    POLICY_ALIAS_DOC_LIBRARY_ADMIN,
    POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY,
    POLICY_ALIAS_LEGACY_DOCUMENTS_LIBRARY_WRITE
  ],
  [POLICY_BACKED_ACCESS_LAI_JAIL]: [
    POLICY_GROUP_LAI_JAIL_READ,
    POLICY_GROUP_LAI_JAIL_WRITE,
    'LAI Jail',
    'LAI Jail (write)'
  ],
  [POLICY_BACKED_ACCESS_LAI_JAIL_WRITE]: [
    POLICY_GROUP_LAI_JAIL_READ,
    POLICY_GROUP_LAI_JAIL_WRITE,
    'LAI Jail',
    'LAI Jail (write)'
  ],
  [POLICY_BACKED_ACCESS_MEDCALL_STANDARD]: [
    POLICY_GROUP_MEDCALL_STANDARD,
    POLICY_GROUP_MEDCALL_POWER_USER,
    POLICY_ALIAS_MEDCALL_STANDARD,
    POLICY_ALIAS_LEGACY_MEDCALL,
    POLICY_ALIAS_MEDCALL_POWER_USER
  ],
  [POLICY_BACKED_ACCESS_MEDCALL_POWER_USER]: [
    POLICY_GROUP_MEDCALL_STANDARD,
    POLICY_GROUP_MEDCALL_POWER_USER,
    POLICY_ALIAS_MEDCALL_STANDARD,
    POLICY_ALIAS_LEGACY_MEDCALL,
    POLICY_ALIAS_MEDCALL_POWER_USER
  ],
  [POLICY_BACKED_ACCESS_NOTIFICATION_LOG]: [
    POLICY_GROUP_NOTIFICATION_LOG,
    'Notification Log'
  ],
  [POLICY_BACKED_ACCESS_NOTIFICATIONS_VIA_OUTLOOK]: [
    POLICY_GROUP_NOTIFICATIONS_VIA_OUTLOOK
  ],
  [POLICY_BACKED_ACCESS_REFERRAL_INTAKE]: [
    POLICY_GROUP_REFERRAL_INTAKE,
    'tools:referraltool',
    'Public Defenders List',
    'Referral Intake',
    'Referral Tool'
  ],
  [POLICY_BACKED_ACCESS_USER_ACCOUNT_REQUESTS]: [
    POLICY_GROUP_USER_ACCOUNT_REQUESTS,
    'Request User Access',
    'User Account Requests',
    'tools:requestuser~full'
  ],
  [POLICY_BACKED_ACCESS_BILLING]: [
    POLICY_GROUP_BILLING,
    'Billing',
    'ecm:dashboard',
    'ecm:dashboard:super',
    'ecm:outreach',
    'ecmdashboard',
    'ecmdashboardaccess',
    'ecmdashboardsuper',
    'ecmdashboardsuperaccess',
    'ecmoutreach',
    'ecmoutreachaccess',
    'legacyecmdashboard',
    'legacyecmdashboardaccess',
    'miftools',
    'miftoolsaccess',
    'providermedicaldemographics',
    'providermedicaldemographicsaccess'
  ],
  [POLICY_BACKED_ACCESS_BILLING_ADMIN]: [
    POLICY_GROUP_BILLING_ADMIN,
    'ecm:dashboard:super',
    'ecmdashboardsuper',
    'ecmdashboardsuperaccess',
    'miftools',
    'miftoolsaccess'
  ]
};

const normalizeKey = (value: unknown) => `${value || ''}`.trim().toLowerCase();

const normalizePolicyListPreservingCase = (values: string[]) => {
  const nextValues: string[] = [];
  const seen = new Set<string>();

  (Array.isArray(values) ? values : []).forEach((value) => {
    const trimmed = `${value || ''}`.trim();
    const key = normalizeKey(trimmed);
    if (!key || seen.has(key)) {
      return;
    }

    seen.add(key);
    nextValues.push(trimmed);
  });

  return nextValues;
};

export const isPolicyBackedPermissionAccess = (value: unknown) => {
  return Object.prototype.hasOwnProperty.call(POLICY_BACKED_ACCESS_MAP, normalizeKey(value));
};

export const getPoliciesForPolicyBackedPermissionAccess = (value: unknown) => {
  return POLICY_BACKED_ACCESS_MAP[normalizeKey(value)] || [];
};

export const applyPolicyBackedPermissionAccessPolicies = (
  currentPolicies: string[],
  enabledPolicyBackedAccesses: string[],
  managedPolicyBackedAccesses: string[] = enabledPolicyBackedAccesses
) => {
  const enabledAccessKeys = Array.from(
    new Set(
      (Array.isArray(enabledPolicyBackedAccesses) ? enabledPolicyBackedAccesses : [])
        .map((value) => normalizeKey(value))
        .filter((value) => isPolicyBackedPermissionAccess(value))
    )
  );
  const managedAccessKeys = Array.from(
    new Set(
      (Array.isArray(managedPolicyBackedAccesses) ? managedPolicyBackedAccesses : [])
        .map((value) => normalizeKey(value))
        .filter((value) => isPolicyBackedPermissionAccess(value))
    )
  );

  let nextPolicies = normalizePolicyListPreservingCase(currentPolicies);
  const managedConflictKeys = new Set(
    managedAccessKeys.flatMap((accessKey) => POLICY_CONFLICT_GROUPS_BY_ACCESS[accessKey] || [])
      .map((policy) => normalizeKey(policy))
  );

  if (managedConflictKeys.size > 0) {
    nextPolicies = nextPolicies.filter((policy) => !managedConflictKeys.has(normalizeKey(policy)));
  }

  enabledAccessKeys.forEach((accessKey) => {
    const conflictKeys = new Set(
      (POLICY_CONFLICT_GROUPS_BY_ACCESS[accessKey] || []).map((policy) => normalizeKey(policy))
    );

    if (conflictKeys.size > 0) {
      nextPolicies = nextPolicies.filter((policy) => !conflictKeys.has(normalizeKey(policy)));
    }

    nextPolicies.push(...getPoliciesForPolicyBackedPermissionAccess(accessKey));
    nextPolicies = normalizePolicyListPreservingCase(nextPolicies);
  });

  return nextPolicies;
};
